<template>
  <div class="payment-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t('prepayments.invoice_prepayment_offer') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/dashboard">{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/dashboard">{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/dashboard">{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/dashboard">{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/invoices">{{ $tc('invoices.invoice', 2) }}</router-link>
        </li>
        <li class="breadcrumb-item">{{ $t('prepayments.invoice_prepayment_offer') }} </li>
      </ol>
      <div v-if="userType=='supplier' && invoiceData.request_level=='Offered'" class="page-actions row">
        <div class="col-xs-2 mr-4">
          <time-counter
            :start-at="{
              'date':offerStartAt
            }"
            :end-at="{
              'date':offerEndAt
          }"/>

        </div>
        <div v-if="!isExpired" class="d-flex align-items-center justify-content-end gap-2">
          <div class="col-xs-2 mr-4">
            <base-button
              v-if="isRejectedButtonShow"
              :loading="isLoading"
              :disabled="isLoading"
              :outline="true"
              size="large"
              icon="times"
              color="theme"
              @click="onRejectedLoan()">
              {{ $t('general.reject') }}
            </base-button>
          </div>
          <div class="col-xs-2">
            <base-button
              v-if="isFinancedButtonShow"
              :loading="isLoading"
              :disabled="isLoading"
              size="large"
              icon="check"
              color="theme"
              @click="onFinancedLoan()">
              {{ $t('general.accept') }}
            </base-button>
          </div>
        </div>
      </div>

    </div>

    <SinglePreapprovedInvoiceRow v-if="$route.name === 'preapproved.invoice.offer'" :fetch-data="fetchData" />
    <SingleInvoiceRow v-else :fetch-data="fetchData" />

    <SingleRequestRow :prepayment-request="prepaymentRequest"/>

  </div>
</template>

<script>

import SingleInvoiceRow from '../invoices/SingleInvoiceRow'
import SinglePreapprovedInvoiceRow from '../preapprovedInvoices/SingleInvoiceRow.vue'
import SingleRequestRow from './SinglePrepaymentRequestRow'
import Attachment from './Attachment'
import { mapActions, mapGetters } from 'vuex'
import MultiSelect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import moment from 'moment'
const { required, between, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  components: { MultiSelect, SingleInvoiceRow, Attachment, SingleRequestRow, SinglePreapprovedInvoiceRow},
  mixins: [validationMixin],
  data () {
    return {
      userType: null,
      fetchData: [],
      isLoading: false,
      isFinancedButtonShow: true,
      isRejectedButtonShow: true,
      prepaymentRequest: [],
      invoiceData: {
        request_level: null
      },
      offerStartAt: null,
      offerEndAt: null,
      isExpired: true
    }
  },
  computed: {},
  watch: {},
  created () {
    if (localStorage.getItem('role') == 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') == 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') == 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') == 'supplier') {
      this.userType = 'supplier'
    }
    this.setInvoiceData()
    this.loadInvoice()
    this.loadRequest()
  },
  validations () {
    return {}
  },
  async mounted () {
    this.checkExpiration()
    this.interval = setInterval(this.checkExpiration, 1000)
    this.$nextTick(() => {

    })
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray',
      'fetchInvoiceShow'
    ]),
    ...mapActions('prepayment', [
      'fetchCreatePayment',
      'addPayment',
      'updatePayment',
      'fetchEditPaymentData',
      'fetchPrePayment',
      'fetchPrePaymentRequest'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('LoanRequest', [
      'loanRequestStatus'
    ]),
    async setInvoiceData () {
      let data = await this.fetchInvoiceShow(this.$route.params.id)
      this.invoiceData = data.data.invoice
    },
    async loadInvoice () {
      if (this.$route.params.id) {
        let response = await this.SingleInvoiceArray(this.$route.params.id)
        if (response.data) {
          this.fetchData = response.data.invoice
        }
      }
    },
    async loadRequest () {
      if (this.$route.params.id) {
        let res = await this.fetchPrePaymentRequest(this.$route.params.id)
        if (res.data) {
          this.prepaymentRequest = res.data.prepaymentRequest
		      this.offerEndAt = res.data.prepaymentRequest[0].offer_expire

          this.offerStartAt = moment().utcOffset()
        }
      }
    },

    checkExpiration () {
      const expireDate = moment(this.offerEndAt)
      const currentDate = moment()
      this.isExpired = expireDate.isSameOrBefore(currentDate)
    },

    async onRejectedLoan () {
      const data = {
        invoice_id: this.$route.params.id,
        request_level: 'Rejected'
      }
      this.isFinancedButtonShow = false
      this.isLoading = true
      let response = await this.loanRequestStatus(data)
      if (response.data.success) {
        this.isLoading = false
        window.toastr['success'](this.$tc('prepayments.offer_reject_message'))
        if (this.$route.name === 'preapproved.invoice.offer') {
          this.$router.push('/supplier/preapproved-invoices')
        } else {
          this.$router.push('/supplier/invoices')
        }
        return true
      }
      if (response.data.error) {
        this.isLoading = false
        window.toastr['error'](response.data.message)
        if (this.$route.name === 'preapproved.invoice.offer') {
          this.$router.push('/supplier/preapproved-invoices')
        } else {
          this.$router.push('/supplier/invoices')
        }
      }
    },
    async onFinancedLoan () {
      const data = {
        invoice_id: this.$route.params.id,
        request_level: 'Financed'
      }
      this.isLoading = true
      this.isRejectedButtonShow = false
      let response = await this.loanRequestStatus(data)
      if (response.data.success) {
        this.isLoading = false
        window.toastr['success'](this.$tc('prepayments.offer_accept_message'))
        if (this.$route.name === 'preapproved.invoice.offer') {
          this.$router.push('/supplier/preapproved-invoices')
        } else {
          this.$router.push('/supplier/invoices')
        }
        return true
      }
      if (response.data.error) {
        this.isLoading = false
        window.toastr['error'](response.data.message)
        if (this.$route.name === 'preapproved.invoice.offer') {
          this.$router.push('/supplier/preapproved-invoices')
        } else {
          this.$router.push('/supplier/invoices')
        }
      }
    }
  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px;
}
</style>
